import { render, staticRenderFns } from "./payOption.vue?vue&type=template&id=2aba5b39&scoped=true&"
import script from "./payOption.vue?vue&type=script&lang=js&"
export * from "./payOption.vue?vue&type=script&lang=js&"
import style0 from "./payOption.vue?vue&type=style&index=0&id=2aba5b39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aba5b39",
  null
  
)

export default component.exports